export class PathsAuditoria {
    public static ProgramaAuditoriaPath = (idPrograma: number) => {
        return `IMGDocumentosAuditoria/${idPrograma}/ProgramaAnualAuditoria/ProgramaAnualAuditoria(${idPrograma}).pdf`;
    }
    public static PlanAuditoriaPath = (idPrograma: number, idAuditoria: number) => {
        return `IMGDocumentosAuditoria/${idPrograma}/${idAuditoria}/PlandeAuditoria/PlandeAuditoria(${idAuditoria}).pdf`;
    }
    public static InformeAuditoriaPath = (idPrograma: number, idAuditoria: number) => {
        return `IMGDocumentosAuditoria/${idPrograma}/${idAuditoria}/InformedeAuditoria/InformeDeauditoria(${idAuditoria}).pdf`;
    }
}